import "../../css/style.css";
import "../../js/main.js";

const aos = require("aos");

export { aos };
